import React from 'react';

import { Text, Box } from '@updater/ui-uds';
import { PageHeading } from '@updater/ui-widgets';
import { useFormNav } from '@updater/ui-informant';

export const ScreenHeading: React.FC = () => {
  const { currentScreenConfig } = useFormNav();
  if (currentScreenConfig) {
    return (
      <Box mt="xs">
        <Box mb="1.25rem">
          <PageHeading as="h2">{currentScreenConfig.heading}</PageHeading>
        </Box>
        {currentScreenConfig.subHeading && (
          <Text variant={['m']} style={{ whiteSpace: 'pre-line' }} mb="28px">
            {currentScreenConfig.subHeading}
          </Text>
        )}
      </Box>
    );
  }
  return null;
};
